import {
  FETCH_COMMERCIAL_TYPES,
  FETCH_COMMERCIAL_TYPES_SUCCESS,
  FETCH_COMMERCIAL_TYPES_FAILED,
  EDIT_COMMERCIAL_TYPE
} from "../store/types";
import { language } from 'config';

export const fetchCommercialTypes = () => (dispatch) => (firebase) => {

  const {
    commercialTypesRef
  } = firebase;

  dispatch({
    type: FETCH_COMMERCIAL_TYPES,
    payload: null
  });
  commercialTypesRef.on("value", snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i] = i;
        return data[i]
      });
      dispatch({
        type: FETCH_COMMERCIAL_TYPES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_COMMERCIAL_TYPES_FAILED,
        payload: language.no_commercials
      });
    }
  });
};

export const editCommercialType = (commercialtypes, method) => (dispatch) => (firebase) => {
  const {
    commercialTypesRef, 
    commercialTypesEditRef
  } = firebase;
  dispatch({
    type: EDIT_COMMERCIAL_TYPE,
    payload: { method, commercialtypes }
  });
  if (method === 'Add') {
    commercialTypesRef.push(commercialtypes);
  } else if (method === 'Delete') {
    commercialTypesEditRef(commercialtypes.id).remove();
  } else {
    commercialTypesEditRef(commercialtypes.id).set(commercialtypes);
  }
}